<template>
  <div>
    <v-chip v-for="file in files" :key="file.Name" :close="isTecnico" color="primary" text-color="white" @click="previewImage($event)"
            @dblclick="downloadFile($event)" @input="remove(file)"
    >
      <v-avatar>
        <v-icon v-if="file.Extension === '.png' || file.Extension === '.jpg' || file.Extension === '.PNG' || file.Extension === '.JPG'">
          image
        </v-icon>
        <v-icon v-if="file.Extension === '.pdf' || file.Extension === '.PDF' || file.Extension === '.xml' || file.Extension === '.XML' || file.Extension === '.odt' || file.Extension === '.ODT'">
          file_copy
        </v-icon>
        <v-icon v-if="file.Extension === '.rar' ">
          folder
        </v-icon>
      </v-avatar>
      {{ file.Name }}
    </v-chip>
  </div>
</template>

<script>
import { EventBus } from '@/store/EventBus.js'

export default {
  name: 'ChipsDrive',
  props: {
    cliente: { type: Number, default: 0 },
    instalacion: { type: Number, default: 0 },
    incidencia: { type: Number, default: 0 }
  },
  data: function () {
    return {
      files: [],
      isTecnico: false,
      profile: this.$store.getters['getProfile']
    }
  },
  mounted () {
    this.loadFiles()
    this.getRol()
  },
  methods: {
    getRol: function () {
      if (this.profile.Role === 'Tecnico') {
        this.isTecnico = true
      }
    },
    createTemplatePNG (urlLink) {
      let componentModalPng = {
        template: `<div id='modalPDF' style='backgroundColor: white;'>
                          <v-container id='containerPDF'>
                            <v-layout id='preViewPDF'>
                              <img src='${urlLink}' />
                            </v-layout> 
                          </v-container>
                        </div>`
      }
      EventBus.$emit('showModal', { component: componentModalPng })
    },
    createTemplateXML (valueText) {
      let componentModalXml = {
        template: `<div id='modalPDF' style='backgroundColor: white; '>
                          <v-container id='containerPDF'>
                            <v-layout id='preViewPDF'>
                              <div style="height: 500px; width:100%;">
                                <v-textarea :value="text" rows="25" readonly></v-textarea> 
                              </div>
                            </v-layout> 
                          </v-container>
                        </div>`,
        data () {
          return {
            text: valueText
          }
        }
      }
      EventBus.$emit('showModal', { component: componentModalXml })
    },
    createTemplatePDF (valuePDF) {
      let componentModalPdf = {
        template: `<div id='modalPDF' style='backgroundColor: black; color: white;'>
                          <v-container id='containerPDF'>
                            <v-layout id='preViewPDF'>
                              <embed src="${valuePDF}" style="width: 2800px; height:500px;" />
                            </v-layout> 
                          </v-container>
                        </div>`
      }
      EventBus.$emit('showModal', { component: componentModalPdf })
    },
    previewImage (event) {
      this.axios
        .get(
          `${this.$apiUrl('file')}?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}&nameFile=${event.target.childNodes[1].nodeValue.trim()}`,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(({ data }) => {
          const fileType = require('file-type')
          var file
          if (fileType(data).ext === 'png' || fileType(data).ext === 'jpg') {
            file = new Blob([data])
            var urlLink = URL.createObjectURL(file)
            this.createTemplatePNG(urlLink)
          }
          if (fileType(data).ext === 'xml') {
            file = new Blob([data], { type: 'text/xml' })
            var enc = new TextDecoder('utf-8')
            var arr = new Uint8Array(data)
            var texto = enc.decode(arr)
            var textString = texto.toString()
            this.createTemplateXML(textString)
          }
          if (fileType(data).ext === 'pdf') {
            file = new Blob([data], { type: 'application/pdf' })
            var urlPDF = URL.createObjectURL(file)
            this.createTemplatePDF(urlPDF)
          }
          if (fileType(data).ext === 'odt') {
            /*
            while (output.firstChild) {
              output.removeChild(output.firstChild)
            } */
          }
        })
    },
    loadFiles () {
      this.axios
        .get(
          `${this.$apiUrl('file')}?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}`,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        )
        .then(({ data }) => {
          this.files = []
          for (let v = 0; v < data.length; v++) {
            this.files.push(data[v])
          }
        })
    },
    downloadFile (event) {
      this.axios
        .get(
          `${this.$apiUrl('file')}?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}&nameFile=${event.target.childNodes[1].nodeValue.trim()}`,
          {
            responseType: 'arraybuffer'
          }
        )
        .then(({ data }) => {
          var file = new Blob([data])
          var fileURL = URL.createObjectURL(file)
          var element = document.createElement('a')
          element.href = fileURL
          element.setAttribute('download', event.target.childNodes[1].nodeValue.trim())
          document.body.appendChild(element)
          element.click()
          document.body.removeChild(element)
        })
    },
    async remove (data) {
      if (!this.disabled) {
        if (await this.confirmRemoveFile(data)) {
          for (let o = 0; o < this.files.length; o++) {
            if (this.files[o].Name === data.Name) {
              this.axios
                .delete(`${this.$apiUrl('file')}?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}&fileName=${this.files[o].Name}`, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                .then(resp => {
                })
              this.files.splice(o, 1)
            }
          }
        }
      }
    },
    async confirmRemoveFile (data) {
      let action = false
      await this.$root.$confirm
        .open(
          'Va a eliminar un archivo.',
          `¿Está seguro de querer eliminar '${data.Name}' ?`,
          {
            preventClose: true,
            ok: { color: 'error', autofocus: true },
            cancel: true
          }
        )
        .then(() => {
          action = true
        })
        .catch(() => {})
      return action
    }
  }
}
</script>

<style>
</style>
